import React from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';

import { BookmarkCouponDrawer } from '../components/BookmarkCouponDrawer';
import { CheckboxItem } from '../components/item/CheckboxItem';
import { NormalItem } from '../components/item/NormalItem';
import { Layout } from '../components/Layout';
import { MaximumBenefitSummary } from '../components/summary/MaximumBenefitSummary';
import { useBenefitService } from '../services/useBenefitService';

export const MaximumBenefitContainer = () => {
  const service = useBenefitService();

  if (service.isHide) {
    return null;
  }

  return (
    <Layout>
      <div ref={service.pageviewTargetRef}>
        <MaximumBenefitSummary {...service.summary} benefitBoxOpen={service.benefitBoxOpen} />

        {service.benefitBoxOpen &&
          service.benefits.map((item, index) => (
            <React.Fragment key={item.title}>
              {item.type === 'checkbox' && (
                <CheckboxItem
                  {...item}
                  borderTopColor={index === 0 ? vars.color.fillPrimary : vars.color.fillSecondary}
                />
              )}
              {item.type === 'normal' && <NormalItem {...item} />}
            </React.Fragment>
          ))}
      </div>

      <BookmarkCouponDrawer
        open={service.bookmarkDrawerOpen}
        onAccept={() => service.addBookmarkAndDownloadCoupon()}
        onDeny={service.closeBookmarkDrawer}
        onClose={service.closeBookmarkDrawer}
      />
    </Layout>
  );
};
